
<p-toast key="linked" position="top-right">
  <ng-template let-msg pTemplate="message">
    <div class="p-toast-message" [ngClass]="'p-toast-message-' + msg.severity">
      <div class="p-toast-message-content">
        <span class="p-toast-summary">{{ msg.summary }}</span>
        <span class="p-toast-detail">
          <!-- Example: Router link -->
          <a [routerLink]="msg.data?.route" (click)="$event.stopPropagation()">
            {{ msg.data?.linkText || 'Open details' }}
          </a>
        </span>
      </div>
    </div>
  </ng-template>
</p-toast>

